const enums = {
    userActionItem: ['Activate', 'Deactivate', 'Unlock', 'Force_Password_Reset'],
    errorCode: ['not_unique'],
};

export default enums;
